import { Button, Tooltip } from '@hubtype/ui-react-web'

import { useFlowBuilderSelector } from '../../../reducer/hooks'
import { ModalType } from '../../modal/modal-types'

export const TransferFlowsButton = (): JSX.Element => {
  const { state, setModalContent } = useFlowBuilderSelector(ctx => ctx)

  const openTransferFlowModal = () => {
    setModalContent({ type: ModalType.TransferFlows })
  }

  const hasOtherBots = state.organizationContents.bots.some(
    bot =>
      bot.id !== state.organizationContents.currentBot.id &&
      bot.flowBuilderSettings?.cmsType === 'flow-builder-backend'
  )

  return (
    <Tooltip
      content='There are no other bots to transfer the flows to'
      isDisabled={hasOtherBots || state.isReadOnly}
    >
      <Button
        intent='secondary'
        size='small'
        appearance='outline'
        onPress={openTransferFlowModal}
        isDisabled={!hasOtherBots || state.isReadOnly}
      >
        Transfer flows
      </Button>
    </Tooltip>
  )
}
